module.exports = __webpack_public_path__ + "static/turquia-007.thumb-7d6b76679acc130ab0273d2ecade4449.jpg";